import React from 'react';
import ContactForm from './ContactForm';

const ContactUs = () => {
    return (
        <main className="page-container">
            <section className="form-section">
                <ContactForm />
            </section>
        </main>
    );
};

export default ContactUs;
